export var DropdownStates;
(function (DropdownStates) {
    DropdownStates["SEARCHING"] = "searching";
    DropdownStates["LIST_CLOSED"] = "listClosed";
    DropdownStates["LIST_OPEN"] = "listOpen";
    DropdownStates["LOCKED"] = "locked";
})(DropdownStates || (DropdownStates = {}));
//# sourceMappingURL=DropdownStates.js.map